import React, { useContext, useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { validateIsNotempty, validateEmail } from '../../../utils';
import MenuItem from '@mui/material/MenuItem';
import DateFnsUtils from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { connect } from 'react-redux';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { getAddressBook } from '../../../actions/userActions';
import { PayloadContext } from '../../../context';
import { getMyActiveLicenses } from '../../../actions/license';

const CreateSchedule = (props) =>
{
	const { open, handleClose, handleSave, data, handleUpdate } = props;
	const n = new Date();

	n.setSeconds(0);
	n.setMilliseconds(0);
	const [ formData, setFormData ] = useState({ meetingName: '', startTime: n.valueOf(), hours: 0, minutes: 0, license: '' });
	const [ invites, setInvites ] = useState([]);
	const [ errorObj, setError ] = useState({});
	const [ addressList, setAddreessData ] = useState([]);
	const inviteRef = useRef(null);
	const { payload } = useContext(PayloadContext);
	const [ licenseListData, setMyLicenses ] = useState([]);

	useEffect(() =>
	{
		if (data && data !== null)
		{
			const _data = { ...data };

			_data['hours'] = Math.floor(data.duration/60);
			_data['minutes'] = Math.floor(data.duration%60);
			_data['license'] = data.license._id;
			// eslint-disable-next-line quotes, no-console
			// console.log('_data ==== ', _data);

      if (data && Array.isArray(data.invites)) {
        // Extract email addresses from data.invites
        const emailArray = data.invites.map(invite => invite.email);
        // Update the invites state with the array of emails
        setInvites(emailArray);
      }
			setFormData({ ..._data });
		}
	}, [ data ]);

	const handleSubmit = () =>
	{
		const { meetingName, startTime, hours, minutes, license } = formData;

		// eslint-disable-next-line quotes, no-console
		// console.log("formData ==== ", formData);
		const now = new Date();

		now.setSeconds(0);
		now.setMilliseconds(0);
		const error = {};
		const duration = hours * 60 + minutes;

		if (!validateIsNotempty(meetingName))
		{
			error['meetingName'] = 'Please Enter Meeting Name';
		}
		// else if (!validateCharecters(meetingName))
		// {
		// 	error['meetingName'] = 'Please Enter valid Meeting Name';
		// }
		// eslint-disable-next-line quotes, no-console
		// console.log(new Date(now), new Date(startTime));

		if (now.valueOf() > startTime)
		{
			error['startTime'] = 'Meeting time should be greater than current time';
		}

		if (duration <= 0)
		{
			error['duration'] = 'Please Enter Meeting duration';
		}
		// else if (!validateNumber(duration))
		// {
		// 	error['duration'] = 'Please Enter duration in minutes';
		// }

		if (!validateIsNotempty(license))
		{
			error['license'] = 'Please select the Room';
		}
		// else if (!validateEmail(email))
		// {
		// 	error['email'] = 'Please Enter valid email';
		// }
		// eslint-disable-next-line quotes, no-console
		// console.log("error ==== ", error);
		if (Object.keys(error).length <= 0)
		{
			setError({});
			const body = { ...formData };

			body['duration'] = duration;
			delete body['hours'];
			delete body['minutes'];
			body['invites'] = invites;
			if (data !== null)
			{
				handleUpdate(data._id, body);
			}
			else
			{
				handleSave(body);
			}
		}
		else
		{
			setError(error);
		}

	};

	// eslint-disable-next-line no-console
	// console.log('// // eslint-disable-next-line no-console', licenseListData);

	const handleChange = (val, name) =>
	{
		setFormData((prevState) => { return { ...prevState, [name]: val }; });
	};

	const licenseList = licenseListData.filter((item) =>
	{
		return item.expireDate > new Date().valueOf();
	});

	const handleAddInvite = (e) =>
	{
		// // eslint-disable-next-line no-console
		// console.log('e === ', e.key);
		if (e.key === 'Enter' || e.key === ',' || e.key === ':')
		{
			const val = e.target.value;

			if (validateEmail(val))
			{
				const inv = [ ...invites ];

				if (!inv.includes(val))
				{
					inv.push(val);
					setInvites([ ...inv ]);
					inviteRef.current.value = '';
					inviteRef.current.focus();
				}

			}
		}
	};

	const handleAdd = (mailid) =>
	{
		const inv = [ ...invites ];

		if (!inv.includes(mailid))
		{
			inv.push(mailid);
			setInvites([ ...inv ]);
		// inviteRef.current.value = '';
		// inviteRef.current.focus();
		}
	};

	const handleInviteKey = (e) =>
	{
		const val = e.target.value;

		if (val === ',' || val === ':')
		{
			inviteRef.current.value = '';
			inviteRef.current.focus();
		}
		else if (val !== '')
		{
			// eslint-disable-next-line no-console
			// console.log('value ==== ', val);
			getAddressBook(val).then((res) =>
			{
				if (res?.data?.status && res?.data?.data)
				{
					setAddreessData([ ...res.data.data ]);
				}
				else
				{
					setAddreessData([]);
				}
			})
				.catch((err) =>
				{
					// eslint-disable-next-line no-console
					console.log('err ==== ', err);
					setAddreessData([]);
				});
		}
	};

	const handleRemove = (i) =>
	{
		const inv = [ ...invites ];

		inv.splice(i, 1);
		setInvites([ ...inv ]);
	};

	useEffect(() =>
	{
		// eslint-disable-next-line no-console
		// console.log('payload.plan', payload.plan);
		if (payload && payload.plan)
		{
			// setLoading(true);
			getMyActiveLicenses('').then((res) =>
			{
				// eslint-disable-next-line no-console
				// console.log('res ==== ', res);
				// setLoading(false);
				if (res && res.status)
				{
					setMyLicenses([ ...res.data.data ]);
				}
				else
				{
					setMyLicenses([]);
				}
			})
				.catch((err) =>
				{
					// eslint-disable-next-line no-console
					console.log('err ==== ', err);
					// setLoading(false);
					setMyLicenses([]);
				});
		}
	}, [ payload, getMyActiveLicenses ]);

	return (
		<Dialog open={open}>
			<DialogTitle>Create Schedule</DialogTitle>
			<DialogContent>
				<TextField
					margin='dense'
					variant='standard'
					id='meetingName'
					label='Meeting Name'
					type='text'
					fullWidth
					autoFocus
					onChange={(e) => handleChange(e.target.value, 'meetingName')}
					value={formData?.meetingName ? formData.meetingName : ''}
					error={errorObj?.meetingName ? true : false}
					helperText={errorObj?.meetingName}
				/>
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<DateTimePicker
						variant='standard'
						fullWidth
						label='Start Time'
						value={new Date(formData.startTime)}
						// inputFormat='DD/MM/YYYY HH:MM'
						onChange={(newdate) =>
						{
							// eslint-disable-next-line quotes, no-console
							// console.log(newdate);
							newdate.setSeconds(0);
							newdate.setMilliseconds(0);
							handleChange(newdate.valueOf(), 'startTime');
						}
						}
						format='MM/dd/yyyy HH:mm'
						disablePast
					/>
					{errorObj?.startTime && <span className='errmsg'>{errorObj?.startTime}</span>}
				</MuiPickersUtilsProvider>
				{/* <TextField
					variant='standard'
					label='Duration (in mins)'
					id='duration'
					type='text'
					fullWidth
					onChange={(e) => handleChange(e.target.value, 'duration')}
					value={formData?.duration ? formData.duration : ''}
					error={errorObj?.duration ? true : false}
					helperText={errorObj?.duration}
				/> */}
				<div className='resRowCol'>
					<div className='flexMinWidthCol resPdngRXS'>
						<TextField
							margin='dense'
							id='hours'
							label='Hours'
							select
							fullWidth
							variant='standard'
							value={formData.hours}
							onChange={(e) => handleChange(e.target.value, 'hours')}
							error={errorObj?.duration ? true : false}
						>
							<MenuItem value={0}>
								0 Hours
							</MenuItem>
							{[ ...Array(4) ].map((item, index) =>
								(<MenuItem key={`${item}Hours`} value={index+1}>
									{index+1} Hours
								</MenuItem>))
							}
						</TextField>
					</div>

					<div className='flexMinWidthCol'>
						<TextField
							margin='dense'
							id='minutes'
							label='Minutes'
							select
							fullWidth
							variant='standard'
							value={formData.minutes}
							onChange={(e) => handleChange(e.target.value, 'minutes')}
							error={errorObj?.duration ? true : false}
						>
							<MenuItem value={0}>
								0 Minutes
							</MenuItem>
							{[ ...Array(59) ].map((item, index) =>
								(<MenuItem key={`${item}Minutes`} value={index+1}>
									{index+1} Minutes
								</MenuItem>))
							}
						</TextField>
					</div>
				</div>
				{errorObj?.duration && <span className='errmsg'>{errorObj?.duration}</span>}

				<TextField
					margin='dense'
					id='license'
					label='Select Room'
					select
					fullWidth
					variant='standard'
					onChange={(e) => handleChange(e.target.value, 'license')}
					value={formData?.license ? formData.license : ''}
					error={errorObj?.license ? true : false}
					helperText={errorObj?.license}
				>
					<MenuItem value=''>
						Select Room
					</MenuItem>
					{licenseList.map((item) => (<MenuItem key={item._id} value={item._id}>
						{item.name}
					</MenuItem>))
					}
				</TextField>
				<div className='flexAutoCol pdngVSM'>
					<TextField
						margin='dense'
						variant='standard'
						// required
						id='invitePeople'
						label='Invite People'
						placeholder='Separate email addresses with comma or semicolon'
						name='invitePeople'
						fullWidth
						className='ipLabel'
						inputRef={inviteRef}
						onKeyDown={(e) => handleAddInvite(e)}
						onKeyUp={(e) => handleInviteKey(e)}
					/>
					<div className='flexRow pdngVSM'>
						<div className='flexWrap brdrRadiusXSM'>
							{invites.map((each, index) => (
								<div key={`invites-${index}`} className='flexInline alignCntr width25 pdngXS'>
									<div className='flexRow pdngXS border brdrRadiusSM'>
										<div className='flexMinWidthCol' title={each}>
											<span className='inviteNames'>{each}</span>
										</div>
										<div className='flexAutoCol' onClick={() => handleRemove(index)}>
											<CloseRoundedIcon/>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
				{addressList && addressList.length > 0 && <div className='flexCol pdngVSM whiteBg border brdrRadiusSM zIndex2 listMainCntnr'>
					<div className='flexCol listCntnr' style={{ padding: '2px' }}>
						{addressList
						// Filter out duplicate emails
							.filter((item, index, self) =>
								index === self.findIndex((t) => t.email === item.email)
							).map((item, index) => (<div key={`addresslist-${index}`} onClick={() => handleAdd(item.email)} className='flexCol alignStrt searchSuggestionList ptr'>
								<span>{item.name}</span>
								<small>{item.email}</small>
							</div>))}
					</div>
				</div>}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleSubmit}>{data && data !== null ? 'Update' : 'Save'}</Button>
			</DialogActions>
		</Dialog>
	);
};

const mapStateToProps = (state) =>
{
	return {
		licenses : state.me.licenses
	};
};

export default connect(
	mapStateToProps,
	null,
	null,
	true
)(CreateSchedule);